import React, {useEffect, useState} from "react";
import './navigator.scss';

import TransitionLink from "gatsby-plugin-transition-link/";


// Defining the <Greeting> component
export const Navigator = (props) => {
  // const context = React.useContext(I18nextContext);
  let lang = props.language
  let trans = props.data;
  // if(context.routed){
  //   lang = context.language;
  // }
  const [visible, setVisibile] = useState(true);
  const [top, setTop] = useState(false);
  const [bottom, setBottom] = useState(false);
  const [left, setLeft] = useState(false);
  const [right, setRight] = useState(false);

  let isChina = lang === "zh_hans" ? true : false;
  
  // const { t } = useTranslation();
  useEffect(() => {
    let pages = [
      {
          currentpage:"index",
          top: "/loro-piana",
          bottom : "/capsule",
          left : "/the-designer",
          right : "/collection",
          isCentralPage: true
      },
      {
        currentpage:"collection",
        top: "/loro-piana",
        bottom : "/capsule",
        left : "/",
        right : "/products",
        isCentralPage: true
      },
      {
        currentpage:"the-designer",
        top: "/loro-piana",
        bottom : "/capsule",
        left : "/stores",
        right : "/",
        isCentralPage: true
      },
      {
        currentpage:"stores",
        top: "/loro-piana",
        bottom : "/capsule",
        left : false,
        right : "/the-designer",
        isCentralPage: true
      },
      {
        currentpage:"products",
        top: "/loro-piana",
        bottom : "/capsule",
        left : "/collection",
        right : false,
        isCentralPage: true
      },
      {
        currentpage:"capsule",
        top: "/",
        bottom : false,
        left : false,
        right : false,
        isCentralPage: false
      },
      {
        currentpage:"loro-piana",
        top: false,
        bottom : "/",
        left : false,
        right : false,
        isCentralPage: false
      }
    ]
    let navigationInfo = pages.filter(page => page.currentpage === props.currentPage);
    setBottom(navigationInfo[0] ? navigationInfo[0].bottom : false);
    setLeft(navigationInfo[0] ? navigationInfo[0].left : false);
    setRight(navigationInfo[0] ? navigationInfo[0].right : false);
    setTop(navigationInfo[0] ? navigationInfo[0].top : false);

    if(navigationInfo[0] && !navigationInfo[0].isCentralPage){
      if(localStorage.getItem('navInfo') != null){
        let navInfo = JSON.parse(localStorage.getItem('navInfo'));
        let page = navInfo.page === 'index' ? '' : navInfo.page;
        if(navInfo.direction === 'bottom'){
          setBottom( "/" + page);
        }else {
          setTop( "/" + page);
        }
      }
    } else if (navigationInfo[0] && navigationInfo[0].isCentralPage) {
      // if the page is a central one remove local storage and follow the standard flow
      localStorage.removeItem("navInfo");
    }

    let lastScroll = 0;
    let scrolled;
    // document.body.addEventListener('onscroll', () => {
    //   console.log('qui')
    // })
    window.addEventListener('scroll', () => {
      
      if(window.pageYOffset > 30 ){
        scrolled = window.pageYOffset;
        if(scrolled > lastScroll ){
          setVisibile(false);
        }else {
          setVisibile(true);
          
        }
        lastScroll = scrolled;
      }
      
    });
    
    
  
  
  }, [props.currentPage]); //rimosso perchè non si aggiornava piu  al cambio pagina (però così passsa due volte)
  // });
  
  function exitAnim() {
    document.body.classList.remove('entry-anim');
    document.body.classList.add('exit-anim');
    
  }


  function entryAnim() {
    document.body.classList.remove('exit-anim');
    document.body.classList.remove('has-glitch')
  
  }

  function entryAnimGlich() {
    document.body.classList.remove('exit-anim');
    document.body.classList.add('has-glitch')
    document.body.classList.remove('glitch-anim');

  }


  function exitAnimGlich() {
    document.body.classList.add('glitch-anim');
    // document.body.classList.add('exit-anim');
    document.body.classList.remove('entry-anim');
  


  
  }



  function storePage(direction) {
    if (localStorage.getItem("navInfo") != null) {
      localStorage.removeItem("navInfo");
    }
    let data = {
      direction: direction,
      page: props.currentPage,
    };
    localStorage.setItem("navInfo", JSON.stringify(data));
  }

  return (
    <div className={"navigator j-navigatorButton" + (visible ? ' navigator--visible' : '')}>
      <button className="navigator__menu  j-menu" onClick={props.openMenu} onKeyPress={props.openMenuEnter}>
        <span className="navigator__menuLabel">{trans['Menu']}</span>
      </button>
      {
        !isChina &&
          <div>
          {top ? (
            <div className="navigator__button navigator__button--top">
              <TransitionLink className = "navigator__buttonLink " aria-label={top}
                exit={{
                  length: 0.7,
                  trigger: ({ exit, node }) =>  exitAnimGlich(exit, node),
          
                }}
                entry={{
                  delay: 0.7,
                  trigger: ({ entry, node }) =>  entryAnimGlich(entry, node),
                }}
                onClick={() => storePage('bottom')}
                to={ "/" + lang + top}  >
              </TransitionLink>
            </div>
          ) : (
            <div className="navigator__button navigator__button--top navigator__button--disabled"></div>
          )}
        </div>
      }
      {
        !isChina &&
          <div>
            {bottom ? (
              <div className="navigator__button navigator__button--bottom" >
                <TransitionLink className = "navigator__buttonLink " aria-label={bottom}
                    exit={{
                      length: 0.7,
                      trigger: ({ exit, node }) =>  exitAnimGlich(exit, node),
              
                    }}
                    entry={{
                      delay: 0.7,
                      trigger: ({ entry, node }) =>  entryAnimGlich(entry, node),
                    }}
                    onClick={() => storePage('top')}
                    to={ "/" + lang + bottom}  >
                </TransitionLink>
              </div>
            ) : (
              <div className="navigator__button navigator__button--bottom navigator__button--disabled"></div>
            )
          }
          </div>
        }
        
      
      
      
      {
         left ? (
          <div className="navigator__button navigator__button--left" >
            <TransitionLink className = "navigator__buttonLink " aria-label={left}
                exit={{
                  length: 0.7,
                  trigger: ({ exit, node }) =>  exitAnim(exit, node),
          
                }}
                entry={{
                  delay: 0.7,
                  trigger: ({ entry, node }) =>  entryAnim(entry, node),
                }}
                to={ "/" + lang + left}  >
            </TransitionLink>
          </div>
         ) : (
          <div className="navigator__button navigator__button--left navigator__button--disabled"></div>
         )
      }
     
      {
       right ? (
          <div className="navigator__button navigator__button--right">
             <TransitionLink className = "navigator__buttonLink "  aria-label={right}
                exit={{
                length: 0.7,
                trigger: ({ exit, node }) =>  exitAnim(exit, node),
        
              }}
              entry={{
                delay: 0.7,
                trigger: ({ entry, node }) =>  entryAnim(entry, node)
              }}
              to={ "/" + lang + right}  >
            </TransitionLink>
          </div>
        ) : (
          <div className="navigator__button navigator__button--right navigator__button--disabled" ></div>
        )
      }
      
    </div>
  );
};
